export class PointDataEvent
{
    static X_CHANGED: string = "PointDataEvent.X_CHANGED";
    static Y_CHANGED: string = "PointDataEvent.Y_CHANGED";
}
